import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import TextField from "@material-ui/core/TextField";
import DateFnsUtils from "@date-io/date-fns";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Legend from "../../../Legend/Legend";

import { ckEditorToolbar } from "../../../../global/ckEditor";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
// Custom Style
import { pasDetailFormStyle } from "../../../../styles/jss/components/PAS/pasDetailFormStyle";
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));

const PasEditDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const {
    pasDetails,
    setPasDetails,
    saleEditorValue,
    setSaleEditorValue,
    progressEditorValue,
    setProgressEditorValue,
  } = props;
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };
  // Handle Form Input
  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...pasDetails };
    data.details[name] = inputData;
    if (name === "sale_preparation") {
      setSaleEditorValue(inputData);
    } else {
      setProgressEditorValue(inputData);
    }

    setPasDetails({ ...pasDetails, ...data });
  };

  return (
    <Fragment>
      <Grid container sapcing={1}>
        <Grid item xs={12}>
          <Paper variant="outlined" elevation={6}>
            <Legend id="sale_preparation" label="Sale Preparation Matters:">
              <Box border={1} borderColor={"grey.500"}>
                <CKEditor
                  editor={ClassicEditor}
                  data={saleEditorValue}
                  fullWidth={true}
                  id={"sale"}
                  name={"sale"}
                  onChange={ckeditorHandleChange("sale_preparation")}
                  config={editorConfiguration}
                />
              </Box>
            </Legend>
          </Paper>
        </Grid>
      </Grid>
      <br />

      <Grid container sapcing={1}>
        <Grid item xs={12}>
          <Paper variant="outlined" elevation={6}>
            <Legend
              id="prog_qual_cost"
              label="Progress / Quality / Cost Matters:"
            >
              <Box border={1} borderColor={"grey.500"}>
                <CKEditor
                  editor={ClassicEditor}
                  data={progressEditorValue}
                  fullWidth={true}
                  id={"prog_qual_cost"}
                  name={"prog_qual_cost"}
                  onChange={ckeditorHandleChange("prog_qual_cost")}
                  config={editorConfiguration}
                />
              </Box>
            </Legend>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default PasEditDetails;
